import Head from "next/head";

import SeoMetaData from "@/components/utils/seo-metadata";
import pageSeoData from "@/data/seo/page-data.json";
import CanparMain from "@/components/fulfilment-partners/canpar-main";
import { GetStaticProps } from "next";
import { PageSeoHeaderProps } from "@/@types/SeoHeader";

export default function UPSCanada({ seoData }: PageSeoHeaderProps) {
  return (
    <>
      <Head>
        <title>{seoData.title}</title>
        <SeoMetaData data={seoData} />
      </Head>

      <CanparMain />
    </>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: { seoData: pageSeoData.PARTNER_CANPAR },
  };
};
